import { render, staticRenderFns } from "./shipment-order-fee-card.vue?vue&type=template&id=c051028a&"
import script from "./shipment-order-fee-card.vue?vue&type=script&lang=js&"
export * from "./shipment-order-fee-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports